import React, { useState, useEffect, useRef, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { get } from 'lodash';
import { usePopper } from 'react-popper';
import { merge } from './helpers.js';

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') { return; }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".styles-module_TooltipWrapperPopper__v9KI8{z-index:5001}.styles-module_ReferenceHidden__3ytOM{visibility:hidden;pointer-events:none}";
var styles = {"TooltipWrapperPopper":"styles-module_TooltipWrapperPopper__v9KI8","ReferenceHidden":"styles-module_ReferenceHidden__3ytOM"};
styleInject(css_248z,{"insertAt":"top"});

var isBoolean = function (value) {
    return value === true || value === false;
};
var PopperInPortal = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.closeOnClick, closeOnClick = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.delay, delay = _e === void 0 ? 0 : _e, _f = _a.enableOverflow, _g = _a.hideEnabled, hideEnabled = _g === void 0 ? false : _g, _h = _a.hoverable, hoverable = _h === void 0 ? true : _h, keyId = _a.keyId, _j = _a.modifiers, modifiers = _j === void 0 ? [] : _j, _k = _a.offset, offset = _k === void 0 ? [0, 10] : _k, placementProp = _a.placement, _l = _a.popperClassName, popperClassName = _l === void 0 ? '' : _l, render = _a.render, _m = _a.shown, shownProp = _m === void 0 ? null : _m;
    var _o = useState(null), referenceRef = _o[0], setReferenceRef = _o[1];
    var _p = useState(null), popperRef = _p[0], setPopperRef = _p[1];
    var isControlled = isBoolean(shownProp);
    var _q = useState(!hoverable), stateShown = _q[0], setStateShown = _q[1];
    var _r = useState(null), arrowRef = _r[0], setArrowRef = _r[1];
    var _s = useState(!disabled && (isControlled ? shownProp : stateShown)), popperVisible = _s[0], setPopperVisible = _s[1];
    var defaultModifiers = [
        {
            name: 'arrow',
            options: {
                element: arrowRef,
            },
        },
        {
            name: 'preventOverflow',
            enabled: true,
        },
        {
            name: 'hide',
            enabled: hideEnabled,
        },
        {
            name: 'offset',
            options: {
                offset: offset,
            },
        },
    ];
    var _t = usePopper(referenceRef, popperRef, {
        strategy: 'fixed',
        placement: placementProp || 'top',
        modifiers: modifiers.length
            ? __spreadArrays(defaultModifiers, modifiers) : defaultModifiers,
    }), popperStyles = _t.styles, attributes = _t.attributes;
    useEffect(function () {
        setPopperVisible(!disabled && (isControlled ? shownProp : stateShown));
    }, [disabled, shownProp, stateShown, isControlled]);
    var timer = useRef();
    useEffect(function () { return function () { return clearTimeout(timer.current); }; }, []);
    var setShownState = function (shown) {
        if (hoverable)
            setStateShown(shown);
    };
    var handleMouseEnterWithDelay = useCallback(function () {
        clearTimeout(timer.current);
        timer.current = window.setTimeout(function () { return setShownState(true); }, delay);
    }, [delay, setShownState]);
    var handleMouseOutWithDelay = useCallback(function () {
        clearTimeout(timer.current);
        setShownState(false);
    }, [setShownState]);
    var handleMouseEnter = function () { return setShownState(true); };
    var handleMouseOut = function () { return setShownState(false); };
    var handleClick = function () {
        if (closeOnClick) {
            handleMouseOut();
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: setReferenceRef, onMouseEnter: handleMouseEnterWithDelay, onMouseMove: handleMouseEnterWithDelay, onMouseLeave: handleMouseOutWithDelay, onClick: handleClick, className: className }, children),
        popperVisible &&
            ReactDOM.createPortal(React.createElement("div", __assign({ key: keyId, className: merge(styles.TooltipWrapperPopper, (get(attributes, ['popper', 'data-popper-reference-hidden'], false) ||
                    get(attributes, ['popper', 'data-popper-escaped'], false)) &&
                    styles.ReferenceHidden, popperClassName), onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseOut, ref: setPopperRef, style: __assign({}, popperStyles.popper) }, attributes.popper), render({
                arrowProps: {
                    style: popperStyles.arrow,
                    setRef: setArrowRef,
                },
                placement: placementProp ||
                    get(attributes, ['popper', 'data-popper-placement'], 'top'),
            })), document.body)));
};

export { PopperInPortal };
